import { CUSTOMER_JOURNEY_NEWS_CATEGORY } from './../const';

function action(catId, token, lang, context, offset, limit) {
  return { type: CUSTOMER_JOURNEY_NEWS_CATEGORY, catId, token, lang, context, offset, limit };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyNewsCategory.js